import { Box, ChatMessage, Divider, Flex, Text } from 'pcln-design-system';
import React from 'react';
import { TravelBotLogoImage } from '../../TravelBotLogoImage';
import MessageFooter from '../MessageFooter/MessageFooter';
export default function ShowCancelConsequencesMarker({
  cancelConsequences
}) {
  var _a;
  const {
    localCurrencyCode,
    localCurrencySymbol,
    roomCharge,
    taxesAndFees,
    subTotal,
    penalty,
    refundAmount,
    hotelName,
    travelDate,
    consequenceHeading,
    consequenceSubHeading,
    consequenceFooter,
    hotelFee,
    previousRefund,
    isPricelineProduct,
    cancellationPolicy
  } = cancelConsequences || {};
  const defaultHeading = `You're requesting to cancel the reservation for ${hotelName || ''} on ${new Date(travelDate)}`;
  const hasPenalty = parseInt(penalty.amountInLocalCurrency) > 0;
  const defaultSubHeading = hasPenalty ? `If you cancel this reservation now, a hotel cancellation penalty of ${localCurrencySymbol || ''}${penalty.amountInLocalCurrency || '0'}${!localCurrencySymbol ? ' USD' : ''} will be applied.` : '';
  const defaultFooter = `Do you want to proceed with the cancellation?`;
  return React.createElement(React.Fragment, null, React.createElement(Box, {
    mb: 3
  }, React.createElement(ChatMessage, {
    ml: '',
    mb: '8px',
    variation: 'initial',
    Icon: TravelBotLogoImage,
    footer: React.createElement(MessageFooter, null),
    message: React.createElement(React.Fragment, null, React.createElement(Text, {
      fontSize: 2,
      mb: 3
    }, consequenceHeading || defaultHeading), React.createElement(Text, {
      fontSize: 2,
      mb: 3
    }, consequenceSubHeading || defaultSubHeading), !!Object.keys(cancellationPolicy || {}).length && !isPricelineProduct && React.createElement(React.Fragment, null, React.createElement(Text, {
      bold: true,
      fontSize: 2,
      mb: 2
    }, cancellationPolicy === null || cancellationPolicy === void 0 ? void 0 : cancellationPolicy.label), React.createElement("ul", null, (_a = cancellationPolicy === null || cancellationPolicy === void 0 ? void 0 : cancellationPolicy.policyText) === null || _a === void 0 ? void 0 : _a.map((policy, index) => {
      return React.createElement("li", {
        key: index
      }, policy);
    }))), React.createElement(Text, {
      bold: true,
      fontSize: 2,
      mb: 2
    }, "Payment Summary"), React.createElement(Divider, null), roomCharge && roomCharge.amountInLocalCurrency && React.createElement(React.Fragment, null, ' ', React.createElement(Flex, {
      justifyContent: 'space-between'
    }, React.createElement(Text, {
      fontSize: 1
    }, (roomCharge === null || roomCharge === void 0 ? void 0 : roomCharge.label) || 'Room Charge'), React.createElement(Flex, null, localCurrencySymbol && React.createElement(Text, {
      fontSize: 1
    }, localCurrencySymbol), React.createElement(Text, {
      fontSize: 1
    }, roomCharge === null || roomCharge === void 0 ? void 0 : roomCharge.amountInLocalCurrency), !localCurrencySymbol && React.createElement(Text, {
      fontSize: 1,
      pl: 1
    }, localCurrencyCode))), React.createElement(Divider, null)), taxesAndFees && taxesAndFees.amountInLocalCurrency && React.createElement(React.Fragment, null, React.createElement(Flex, {
      justifyContent: 'space-between'
    }, React.createElement(Text, {
      fontSize: 1
    }, (taxesAndFees === null || taxesAndFees === void 0 ? void 0 : taxesAndFees.label) || 'Taxes and Fees'), React.createElement(Flex, null, localCurrencySymbol && React.createElement(Text, {
      fontSize: 1
    }, localCurrencySymbol), React.createElement(Text, {
      fontSize: 1
    }, taxesAndFees === null || taxesAndFees === void 0 ? void 0 : taxesAndFees.amountInLocalCurrency), !localCurrencySymbol && React.createElement(Text, {
      fontSize: 1,
      pl: 1
    }, localCurrencyCode))), React.createElement(Divider, null)), hotelFee && hotelFee.amountInLocalCurrency && React.createElement(React.Fragment, null, React.createElement(Flex, {
      justifyContent: 'space-between'
    }, React.createElement(Text, {
      fontSize: 1
    }, (hotelFee === null || hotelFee === void 0 ? void 0 : hotelFee.label) || 'Taxes and Fees'), React.createElement(Flex, null, localCurrencySymbol && React.createElement(Text, {
      fontSize: 1
    }, localCurrencySymbol), React.createElement(Text, {
      fontSize: 1
    }, hotelFee === null || hotelFee === void 0 ? void 0 : hotelFee.amountInLocalCurrency), !localCurrencySymbol && React.createElement(Text, {
      fontSize: 1,
      pl: 1
    }, localCurrencyCode))), React.createElement(Divider, null)), subTotal && subTotal.amountInLocalCurrency && React.createElement(React.Fragment, null, React.createElement(Flex, {
      justifyContent: 'space-between'
    }, React.createElement(Text, {
      fontSize: 1
    }, (subTotal === null || subTotal === void 0 ? void 0 : subTotal.label) || 'Subtotal'), React.createElement(Flex, null, localCurrencySymbol && React.createElement(Text, {
      fontSize: 1
    }, localCurrencySymbol), React.createElement(Text, {
      fontSize: 1
    }, subTotal === null || subTotal === void 0 ? void 0 : subTotal.amountInLocalCurrency), !localCurrencySymbol && React.createElement(Text, {
      fontSize: 1,
      pl: 1
    }, localCurrencyCode))), React.createElement(Divider, null)), previousRefund && previousRefund.amountInLocalCurrency && React.createElement(React.Fragment, null, React.createElement(Flex, {
      justifyContent: 'space-between'
    }, React.createElement(Text, {
      fontSize: 1
    }, (previousRefund === null || previousRefund === void 0 ? void 0 : previousRefund.label) || 'Subtotal'), React.createElement(Flex, null, localCurrencySymbol && React.createElement(Text, {
      fontSize: 1
    }, localCurrencySymbol), React.createElement(Text, {
      fontSize: 1
    }, previousRefund.amountInLocalCurrency), !localCurrencySymbol && React.createElement(Text, {
      fontSize: 1,
      pl: 1
    }, localCurrencyCode))), React.createElement(Divider, null)), hasPenalty && React.createElement(React.Fragment, null, React.createElement(Flex, {
      justifyContent: 'space-between'
    }, React.createElement(Text, {
      fontSize: 1,
      color: 'warning'
    }, (penalty === null || penalty === void 0 ? void 0 : penalty.label) || 'Penalty Fee'), React.createElement(Flex, null, React.createElement(Text, {
      fontSize: 1,
      color: 'warning'
    }, "-"), localCurrencySymbol && React.createElement(Text, {
      fontSize: 1,
      color: 'warning'
    }, localCurrencySymbol), React.createElement(Text, {
      fontSize: 1,
      color: 'warning'
    }, penalty === null || penalty === void 0 ? void 0 : penalty.amountInLocalCurrency), !localCurrencySymbol && React.createElement(Text, {
      color: 'warning',
      fontSize: 1,
      pl: 1
    }, localCurrencyCode))), React.createElement(Divider, null)), refundAmount && refundAmount.amountInLocalCurrency && React.createElement(Flex, {
      justifyContent: 'space-between'
    }, React.createElement(Text, {
      fontSize: 1,
      color: 'success',
      bold: true
    }, (refundAmount === null || refundAmount === void 0 ? void 0 : refundAmount.label) || 'Refund Amount'), React.createElement(Flex, null, localCurrencySymbol && React.createElement(Text, {
      fontSize: 1,
      color: 'success',
      bold: true
    }, localCurrencySymbol), React.createElement(Text, {
      fontSize: 1,
      color: 'success',
      bold: true
    }, refundAmount === null || refundAmount === void 0 ? void 0 : refundAmount.amountInLocalCurrency), !localCurrencySymbol && React.createElement(Text, {
      color: 'success',
      fontSize: 1,
      pl: 1,
      bold: true
    }, localCurrencyCode))), React.createElement(Text, {
      mt: 3
    }, consequenceFooter || defaultFooter))
  })));
}